<p-tabView (onChange)="onTabChange($event)">
    <p-tabPanel header="Overview">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-field p-formgrid p-grid">
                        <div class="p-col-12 p-md-4">
                            <div class="p-fluid">
                                <div class="card" style="min-height: 160px">
                                    <h6 class="p-mb-0">Vendor Information</h6>
                                    <p class="p-mb-0"> {{ billDetails?.vendorBusinessName }} </p>
                                    <p class="p-mb-0"> {{ billDetails?.shippingAddress ?.streetAddress1 }}<span *ngIf="
                                                        billDetails?.shippingAddress
                                                            ?.streetAddress1
                                                    ">,</span>
                                    </p>
                                    <p class="p-mb-0">
                                        {{billDetails?.shippingAddress?.streetAddress2}}<span *ngIf="
                                                        billDetails?.shippingAddress
                                                            ?.streetAddress2
                                                    ">,</span>
                                    </p>
                                    <p class="p-mb-0">
                                        {{
                                        billDetails?.shippingAddress?.city
                                        ?.name
                                        }}<span *ngIf="
                                                        billDetails?.shippingAddress
                                                            ?.city?.name
                                                    ">,
                                        </span> {{ billDetails?.shippingAddress?.state ?.name }}<span *ngIf="
                                                        billDetails?.shippingAddress
                                                            ?.state?.name
                                                    ">,
                                        </span> {{ billDetails?.shippingAddress?.country ?.name }} <span *ngIf="
                                                        billDetails?.shippingAddress
                                                            ?.country?.name
                                                    ">,
                                        </span> {{ billDetails?.shippingAddress?.zipCode }} </p>
                                    <p class="p-mb-0"> {{ billDetails?.contact?.firstName }} {{
                                        billDetails?.contact?.lastName
                                        }} </p>
                                    <p class="p-mb-0"> {{ billDetails?.contact ?.contactPhones[0]?.phone ?.number }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <div class="p-fluid">
                                <div class="card" style="min-height: 160px">
                                    <h6 class="p-mb-0">Shipping</h6>
                                    <p class="p-mb-0"> {{ app?.user?.organizationName }} </p>
                                    <p class="p-mb-0"> {{ billDetails?.warehouse?.name }}-{{
                                        billDetails?.warehouse?.locationId
                                        }} </p>
                                    <p class="p-mb-0"> {{ billDetails?.warehouse?.address ?.streetAddress1 }}<span
                                            *ngIf="
                                                        billDetails?.warehouse?.address
                                                            ?.streetAddress1
                                                    ">,</span>
                                    </p>
                                    <p class="p-mb-0">
                                        {{
                                        billDetails?.warehouse?.address
                                        ?.streetAddress2
                                        }}<span *ngIf="
                                                        billDetails?.warehouse?.address
                                                            ?.streetAddress2
                                                    ">,</span>
                                    </p>
                                    <p class="p-mb-0">
                                        {{
                                        billDetails?.warehouse?.address?.city
                                        ?.name
                                        }}<span *ngIf="
                                                        billDetails?.warehouse?.address
                                                            ?.city?.name
                                                    ">,
                                        </span> {{ billDetails?.warehouse?.address ?.state?.name }}<span *ngIf="
                                                        billDetails?.warehouse?.address
                                                            ?.state?.name
                                                    ">,
                                        </span> {{ billDetails?.warehouse?.address ?.country?.name }}<span *ngIf="
                                                        billDetails?.warehouse?.address
                                                            ?.country?.name
                                                    ">,
                                        </span> {{ billDetails?.warehouse?.address ?.zipCode }} </p>
                                    <p class="p-mb-0"> {{ billDetails?.warehouse?.contactPersonName }} </p>
                                    <p class="p-mb-0"> {{ billDetails?.warehouse?.phoneNo}} </p>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <div class="p-fluid">
                                <div class="card" style="min-height: 160px">
                                    <p class="p-mb-0"> Bill No.: {{ billDetails?.number }} </p>
                                    <p class="p-mb-0"
                                        *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[0]?.isChecked">
                                        {{billTemplate && billTemplate.labels_misc &&
                                        billTemplate.labels_misc[0]?.labelname}}:
                                        {{billDetails?.createdDate | date: 'MM/dd/yyyy'}}
                                    </p>
                                    <p class="p-mb-0" *ngIf="isAllowPostingPeriod">
                                        <span>Posting Period:{{ billDetails?.postingDate ? (billDetails?.postingDate | date: 'MMMM yyyy') : null }}</span>
                                    </p>
                                    <p class="p-mb-0"
                                        *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[2]?.isChecked">
                                        {{billTemplate && billTemplate.labels_misc &&
                                        billTemplate.labels_misc[2]?.labelname}}:
                                        {{billDetails?.currencyUnit?.symbol}} {{billDetails?.billAmount |
                                        customNumberFormat: length }}
                                    </p>
                                    <p class="p-mb-0"> PO No.: {{ billDetails?.poNumber }}</p>
                                    <p class="p-mb-0"> Bill Status: {{ billDetails?.billStatus }} </p>
                                    <p class="p-mb-0"> Received By: {{ billDetails?.createdByUser }} </p>
                                    <p class="p-mb-0"> Reference No.: {{billDetails?.referenceNo}}</p>
                                    <p class="p-mb-0"> Currency: 1 {{baseCurrency?.code}} =
                                        {{billDetails?.exchangeRate}} {{billDetails?.currencyUnit?.code}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-field p-formgrid p-grid">
                        <div class="p-col" *ngIf="billTemplate && billTemplate.labels_section[0]?.isChecked">
                            <div class="card">
                                <h6 class="p-mb-0">{{billTemplate && billTemplate.labels_section[0]?.labelname}}</h6>
                                <p class="p-mb-0"> {{ billDetails?.paymentTerm?.name }} </p>
                            </div>
                        </div>
                        <div class="p-col" *ngIf="billTemplate && billTemplate.labels_section[1]?.isChecked">
                            <div class="card">
                                <h6 class="p-mb-0">{{billTemplate && billTemplate.labels_section[1]?.labelname}}</h6>
                                <p class="p-mb-0"> {{ billDetails?.paymentMethod?.name }} </p>
                            </div>
                        </div>
                        <div class="p-col" *ngIf="billTemplate && billTemplate.labels_section[2]?.isChecked">
                            <div class="card">
                                <h6 class="p-mb-0">{{billTemplate && billTemplate.labels_section[2]?.labelname}}</h6>
                                <p class="p-mb-0"> {{ billDetails?.shippingTerm?.name }} </p>
                            </div>
                        </div>
                        <div class="p-col" *ngIf="billTemplate && billTemplate.labels_section[3]?.isChecked">
                            <div class="card">
                                <h6 class="p-mb-0">{{billTemplate && billTemplate.labels_section[3]?.labelname}}</h6>
                                <p class="p-mb-0"> {{ billDetails?.shippingMethod?.name }} </p>
                            </div>
                        </div>
                        <div class="p-col" *ngIf="billTemplate && billTemplate.labels_section[4]?.isChecked">
                            <div class="card">
                                <h6 class="p-mb-0">{{billTemplate && billTemplate.labels_section[4]?.labelname}}</h6>
                                <p class="p-mb-0">
                                    {{ billDetails?.userName }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <p-tabView class="custom-header" [(activeIndex)]="index">
                        <p-tabPanel>
                            <ng-template pTemplate="header">
                                <div class="p-d-flex p-jc-between" style="width: 100%"> <span>Expenses</span> </div>
                            </ng-template>
                            <p-table [value]="expenses" responsiveLayout="scroll">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Chart of Account</th>
                                        <th>Memo</th>
                                        <th>Amount</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-expense>
                                    <tr>
                                        <td>{{ expense.financialAccount }}</td>
                                        <td>{{ expense.description }}</td>
                                        <td>{{billDetails?.currencyUnit?.symbol}} {{ expense.amount |
                                            customNumberFormat: length }} </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                    <tr>
                                        <td colspan="2" class="p-text-right"> Subtotal </td>
                                        <td>{{billDetails?.currencyUnit?.symbol}} {{ (billDetails?.totalExpenseAmount *
                                            billDetails?.exchangeRate) | customNumberFormat: length }} </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage" let-columns>
                                    <tr>
                                        <td colspan="7" class="p-text-center">
                                            No expense account found.
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabPanel>
                        <p-tabPanel>
                            <ng-template pTemplate="header">
                                <div class="p-d-flex p-jc-between" style="width: 100%"> <span>Items</span> </div>
                            </ng-template>
                            <p-table [value]="receivePurchaseListTB"
                                styleClass="p-datatable-gridlines p-datatable-striped">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th colspan="1">PO No.</th>
                                        <th colspan="1">Item</th>
                                        <th colspan="4">Description</th>
                                        <th colspan="1">UOM</th>
                                        <th colspan="1">Cost</th>
                                        <th colspan="1">Qty</th>
                                        <th colspan="1">Serial No.</th>
                                        <th colspan="1" *ngIf="billTemplate?.labels_table[6]?.isChecked">
                                            {{billTemplate
                                                &&
                                                billTemplate.labels_table && billTemplate.labels_table[6]?.labelname}}
                                        </th>
                                        <th colspan="1" *ngIf="billTemplate?.labels_table[5]?.isChecked">{{billTemplate
                                            &&
                                            billTemplate.labels_table && billTemplate.labels_table[5]?.labelname}}
                                        </th>
                                        <th colspan="1">{{billTemplate && billTemplate.labels_table &&
                                            billTemplate.labels_table[4]?.labelname}}
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-product>
                                    <tr>
                                        <td colspan="1">{{product.poNo ? product.poNo : 'N/A'}}</td>
                                        <td colspan="1"> {{ product.itemNo }} </td>
                                        <td colspan="4"> {{ product.description | shorten: 55}} </td>
                                        <td colspan="1"> <span *ngIf="product.typeId != 4">{{
                                                product.uom
                                                }}</span> </td>
                                        <td colspan="1"> <span
                                                *ngIf="product.typeId != 4">{{billDetails?.currencyUnit?.symbol}} {{
                                                product.pricePerProduct | customNumberFormat: length }}</span> </td>
                                        <td colspan="1"> {{ product.quantity | customNumberFormat: qtyDecimal }} </td>
                                        <td colspan="1">
                                            <span class="btnBars p-mt-2 badge" *ngIf="
                                                product.typeId != 4 &&
                                                product.trackingEnabled" (click)="showScanInfo(product)">
                                                <i class="pi pi-th-large" pBadge value="{{product.serialCount}}"
                                                    severity="warning"></i>
                                            </span>
                                        </td>
                                        <td colspan="1">{{billDetails?.currencyUnit?.symbol}} {{ product.cost |
                                            customNumberFormat: length }} </td>
                                        <td colspan="1" *ngIf="billTemplate?.labels_table[5]?.isChecked">
                                            {{billDetails?.currencyUnit?.symbol}} {{product.taxAmount |
                                            customNumberFormat:
                                            length }}
                                        </td>
                                        <td colspan="1">{{billDetails?.currencyUnit?.symbol}} {{product.netAmount |
                                            customNumberFormat:
                                            length }}
                                        </td>
                                    </tr>
                                    <!-- bundle items -->
                                    <tr *ngFor="let bundle of product.products;let i = index" class="bundleRow">
                                        <td colspan="1">{{product.poNo ? product.poNo : 'N/A'}}</td>
                                        <td colspan="1"> {{ bundle.itemNo ? bundle.itemNo : null }} </td>
                                        <td colspan="4"> {{ bundle.description?.length > 55 ? (bundle.description |
                                            slice : 0 :
                                            55) + "..." : bundle.description }} </td>
                                        <td colspan="1"> {{ bundle.uom ? bundle.uom : null }} </td>
                                        <td colspan="1"> {{ bundle.pricePerProduct | customNumberFormat: length |
                                            currencySymbol }} </td>
                                        <td colspan="1"> {{ bundle.quantity }} </td>
                                        <td colspan="1">
                                            <span class="btnBars p-mt-2 badge" *ngIf="bundle.trackingEnabled"
                                                (click)="showScanInfo(bundle)">
                                                <i class="pi pi-th-large" pBadge value="{{bundle.serialCount}}"
                                                    severity="warning"></i>
                                            </span>
                                        </td>
                                        <td colspan="2"> {{ bundle.cost | customNumberFormat: length | currencySymbol }}
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage" let-columns>
                                    <tr>
                                        <td colspan="12" class="p-text-center">
                                            No items found.
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                    <tr>
                                        <td></td>
                                        <td>Total</td>
                                        <td colspan="4"></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td *ngIf="billTemplate?.labels_table[6]?.isChecked">{{billDetails?.currencyUnit?.symbol}} {{subTotal | customNumberFormat: length }}</td>
                                        <td *ngIf="billTemplate?.labels_table[5]?.isChecked">
                                          {{billDetails?.currencyUnit?.symbol}} {{billDetails?.taxAmount | customNumberFormat: length }}
                                        </td>
                                        <td>{{billDetails?.currencyUnit?.symbol}} {{lineTotal | customNumberFormat: length }}</td>
                                      </tr>
                                    <tr>
                                        <td [attr.colspan]="(billTemplate?.labels_table[5]?.isChecked ? 12 : 11)" class="p-text-right"> Freight </td>
                                        <td colspan="3"> <span>{{billDetails?.currencyUnit?.symbol}} {{
                                                shippingAmount
                                                | customNumberFormat: length }}</span> </td>
                                    </tr>
                                    <tr>
                                        <td [attr.colspan]="(billTemplate?.labels_table[5]?.isChecked ? 12 : 11)" class="p-text-right"> Discount </td>
                                        <td colspan="3">{{billDetails?.currencyUnit?.symbol}} {{ discount |
                                            customNumberFormat: length }} </td>
                                    </tr>
                                    <tr *ngIf="footerTaxEnabled">
                                        <td colspan="11" class="p-text-right"> Tax </td>
                                        <td colspan="3">{{billDetails?.currencyUnit?.symbol}} {{ billDetails?.taxAmount |
                                            customNumberFormat: length }} </td>
                                    </tr>
                                    <tr>
                                        <td [attr.colspan]="(billTemplate?.labels_table[5]?.isChecked ? 12 : 11)" class="p-text-right"> Order total </td>
                                        <td colspan="3">{{billDetails?.currencyUnit?.symbol}} {{ orderTotal |
                                            customNumberFormat: length }} </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabPanel>
                    </p-tabView>
                    <div class="p-field p-formgrid p-grid">
                        <div class="p-col-12">
                            <p>Notes: {{ notes }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        @if(!isView){
        <app-edit-bill [selectedBill]="billDetails" [selectedChannel]="selectedChannel" [baseCurrency]="baseCurrency"
            [orgCurrency]="orgCurrency" (loadList)="updateJournal()" (onClose)="closeDialog()"></app-edit-bill>
        }

    </p-tabPanel>
    <p-tabPanel header="Impacts on G/L">
        <app-inventory-impacts-gl [selectedId]="billId" [objectTypeId]="transactionTypeIds.Bill"
            [callApi]="glApiCall"></app-inventory-impacts-gl>
    </p-tabPanel>
</p-tabView>